import { CW_STATUS_PUB } from '../const/course'

// 课程

class Course {
  constructor(c) {
    Object.assign(this, c)

    const { detail } = this
    if (detail) {
      // 去除样式、事件
      this.detail = detail.replace(/\b(?:style|on\w+)=(['"])(.*?)\1/g, '')
    }
  }
}

export function KCourse(course) {
  return new Course(course)
}

class CourseWare {
  constructor(c) {
    Object.assign(this, c)
    this.status = +this.status

    // console.log(this.status)
  }
  // 是否可播放
  get canPlay() {
    return !!this.isPub && !!this.url
  }
  // 是否已发布
  get isPub() {
    return this.status === CW_STATUS_PUB
  }
}

export function KCourseWare(course) {
  return new CourseWare(course)
}
